import { useState } from 'react'
import ExclamationTriangleIcon from '@icons/exclamation-triangle'
import { AppService } from '@/lib/services/AppService'
import { Notify } from '@/lib/misc/Notify'
import CheckCircleIcon from '@icons/check-circle'
import Button from './Button'

const EmailVerificationBanner = () => {
  const [isResendingEmail, setIsResendingEmail] = useState(false)
  const [hasResentEmail, setHasResentEmail] = useState(false)

  const handleResendVerificationEmail = async () => {
    setIsResendingEmail(true)

    try {
      const appService = new AppService()
      await appService.resendVerificationEmail()
      Notify.success('Verification email sent successfully!')
      setHasResentEmail(true)
    } catch {
      Notify.error('Failed to send verification email. Please try again.')
    } finally {
      setIsResendingEmail(false)
    }
  }

  return (
    <div className="page-shell pt-4">
      <div className="flex flex-wrap items-center justify-between gap-x-4 gap-y-2.5 rounded-xl bg-status-warning-100 px-4 py-3 ring-1 ring-status-warning-300/70 ring-inset">
        <div className="flex min-w-0 items-center gap-2.5">
          <ExclamationTriangleIcon className="size-5 shrink-0 text-status-warning-700" />
          <span className="text-[14px] leading-[1.45] text-status-warning-900">
            Please verify your email address to access all features.
          </span>
        </div>

        {hasResentEmail ? (
          <div className="flex h-7 items-center gap-2">
            <CheckCircleIcon className="size-5 shrink-0 text-status-good" />
            <span className="text-[14px] leading-[1.45] text-status-warning-900">
              Verification email sent — check your inbox.
            </span>
          </div>
        ) : (
          <Button
            style="secondary"
            size="sm"
            loading={isResendingEmail}
            onClick={handleResendVerificationEmail}
            disabled={isResendingEmail}
            cy="resend-verification-email-btn"
          >
            {isResendingEmail ? 'Sending...' : 'Resend email'}
          </Button>
        )}
      </div>
    </div>
  )
}

export default EmailVerificationBanner
